import React from "react";
import "./NewButton.css";
import { useScreenTransition } from "../Hooks/useScreenTransition";
import { ReactComponent as ChevronLeft } from "../assets/icons/ChevronLeft.svg";
import { ReactComponent as Send } from "../assets/icons/Send.svg";

const NewButton = ({
  text,
  transition,
  back,
  width = "240px",
  disabled,
  onClick,
  transitionProhibited,
  icon = true,
  whiteBtn = false,
  deleteBtn,
  smallPadding,
  sendIcon = false,
  customIcon,
  className = ""
}) => {
  const { transitionTo } = useScreenTransition();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      if (!transitionProhibited && transition) {
        transitionTo(transition, e);
      }
    }
  };
  if (back) {
    return (
      <button disabled={disabled} className={`${className} backToTypeOrder ${smallPadding ? "btnSmallPadding" : ""}`} onClick={handleClick} style={{width: window.innerWidth < 800 ? "fit-content" : width, backgroundColor: whiteBtn ? "#fff" : "#f3f3f3", 
      borderColor: whiteBtn ? "#E6E7E9" : "#030F23", color: whiteBtn ? "#030F23" : "#030F23"}}>
        {window.innerWidth > 900 ? icon ? customIcon ?  customIcon : (
          <ChevronLeft className="backToOrderIcon" />
        ) : sendIcon ? <Send /> : null : null}
        {text}
      </button>
    );
  }

  return (
    <button
      disabled={disabled}
      style={{ width: width }}
      className={`${className} mainOrderTypeOptionButton ${deleteBtn ? "mainOrderTypeDeleteButton" : ""} ${smallPadding ? "btnSmallPadding" : ""}`}
      onClick={handleClick}
    >
      {icon && customIcon &&  customIcon}
      {text}
    </button>
  );
};

export default NewButton;
